import styled from "styled-components";

export const Container = styled.div`
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  gap: 15px;
`;

export const StockLogo = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 8px;
`;

export const StockInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const StockName = styled.h1`
  margin: 0;
  font-size: 18px;
  color: #c5a55c;
  font-weight: 600;
`;

export const PriceInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const Price = styled.span`
  font-size: 20px;
  font-weight: bold;
`;

export const PriceChange = styled.span`
  color: ${(props) => (props.isPositive ? "#22c55e" : "#ef4444")};
  font-size: 16px;
`;

export const QuestionsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-top: 20px;
`;

export const QuestionCard = styled.div`
  background-color:rgba(255, 255, 255, 0.08);
  padding: 24px;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  color: #c5a55c;
  border: 1px solid #e0e0e0;
  min-height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: relative;
  overflow: hidden;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
    border-color: #d4af37;
  }

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #e6c158, #b08a1a);
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &:hover::before {
    opacity: 1;
  }
`;

export const LoadingCard = styled.div`
  background-color: #ffffff;
  padding: 24px;
  border-radius: 12px;
  min-height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e0e0e0;
  animation: pulse 1.5s infinite;

  @keyframes pulse {
    0% {
      opacity: 0.6;
    }
    50% {
      opacity: 0.8;
    }
    100% {
      opacity: 0.6;
    }
  }
`;

export const AnswerContainer = styled.div`
  background-color: #ffffff;
  padding: 30px;
  border-radius: 15px;
  color: #1a1a1a;
  border: 1px solid #e0e0e0;
  margin-top: 20px;
`;

export const AnswerModal = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #ffffff;
  padding: 30px;
  border-radius: 15px;
  width: 80%;
  max-width: 800px;
  max-height: 80vh;
  overflow-y: auto;
  z-index: 1000;
  color: #1a1a1a;

  h2 {
    color: #1a1a1a;
    margin-top: 0;
  }
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 999;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
`;

export const AnswerContent = styled.div`
  h2 {
    color: #d4af37;
    margin-top: 0;
    margin-bottom: 20px;
  }
`;

export const AnswerText = styled.div`
  line-height: 1.6;
  color: #4a4a4a;
  white-space: pre-wrap;
`;

export const FollowUpQuestions = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
  padding: 12px 0;
  margin: 8px 0;
  width: 100%;
  max-width: 100%;
  position: relative;
  z-index: 0;
`;

export const BackButton = styled.button`
  background: none;
  border: none;
  color: #d4af37;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  margin: 0;
  font-weight: 500;

  &:hover {
    color: #e6c158;
  }
`;

export const PortalBadge = styled.div`
  display: inline-flex;
  background: transparent;
  color: #ff7b00;
  font-weight: bold;
  font-size: 18px;
  position: relative;
  margin-left: 10px;
  padding: 5px 10px;

  &::after {
    content: "+";
    position: absolute;
    top: 0;
    right: -5px;
    font-size: 14px;
    color: #ff7b00;
  }
`;

export const AnalysisHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0;
  font-size: 18px;
  font-weight: bold;
`;

export const PriceTag = styled.span`
  font-size: 18px;
  margin-right: 10px;
`;

export const AnalysisActionButton = styled.button`
  background-color: #f5f5f5;
  color: #1a1a1a;
  border: none;
  width: 100%;
  padding: 15px;
  border-radius: 10px;
  text-align: left;
  font-size: 16px;
  margin: 20px 0;
  cursor: pointer;

  &:hover {
    background-color: #e0e0e0;
  }
`;

export const AnalysisTitle = styled.h2`
  font-size: 24px;
  font-weight: bold;
  margin: 25px 0 15px;
  color: white;
`;

export const AnalysisSection = styled.div`
  margin-bottom: 20px;
  background-color: #1c1c1c;
  border-radius: 8px;
  padding: 15px;

  &:hover {
    background-color: #252525;
  }
`;

export const SectionTitle = styled.h3`
  font-size: 18px;
  margin: 0 0 10px;
  color: white;
`;

export const SectionContent = styled.p`
  margin: 0;
  color: #cccccc;
  font-size: 15px;
  line-height: 1.5;
`;

export const SearchContainer = styled.div`
  position: relative;
  margin-top: 20px;
  width: 100%;
`;

export const SearchBar = styled.input`
  width: 100%;
  padding: 10px 20px;
  margin: 40px 0 20px;
  border: 1px solid #c5a55c;
  border-radius: 8px;
  background-color:var(--navbar-bg);
  color: white;
  font-size: 16px;
  transition: all 0.3s ease;

  &:focus {
    outline: none;
    border-color: #c5a55c;
    box-shadow: 0 0 0 2px rgba(212, 175, 55, 0.2);
  }

  &::placeholder {
    color: #c5a55c;
  }
`;

export const SubmitButton = styled.button`
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 8px;
  color: #b08a1a;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: #e6c158;
  }
`;

export const ChatContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 89vh;
  width: 100%;
  background-color:rgba(245, 245, 245, 0);
  bottom: 0;
  margin: 0;
  padding: 0;
  overflow: hidden;
    @media (max-width: 992px) {
    height: 79vh;
  }
`;

export const ChatHeader = styled.div`
  padding: 20px;
  background-color:rgba(255, 255, 255, 0.13);
  border-bottom: 1px solidrgb(114, 114, 114);
  position: sticky;
  top: 0;
  z-index: 10;
  flex-shrink: 0;
`;

export const ChatMessages = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  position: relative;

  /* Hide scrollbar for WebKit-based browsers (Chrome, Safari) */
  &::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for Firefox */
  scrollbar-width: none;

  /* Optional: prevent scroll thumb interaction */
  -ms-overflow-style: none; /* IE and Edge */
`;


// export const Message = styled.div`
//   max-width: 85%;
//   padding: 12px 25px;
//   border-radius: 16px;
//   background-color: ${(props) => (props.isUser ? "#D4AF37" : "#ffffff")};
//   color: ${(props) => (props.isUser ? "#ffffff" : "#1a1a1a")};
//   align-self: ${(props) => (props.isUser ? "flex-end" : "flex-start")};
//   word-wrap: break-word;
//   box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
//   text-align: ${(props) => (props.isUser ? "right" : "left")};
//   font-size: 15px;
//   line-height: 1.4;
// `;

export const Message = styled.div`
  max-width: 85%;
  padding: 12px 25px;
  border-radius: 16px;
  background-color: ${(props) =>
    props.isUser ? "var(--gold)" : "var(--body-bg)"};
  color: ${(props) =>
    props.isUser ? "#ffffff" : "var(--tittle-text)"};
  align-self: ${(props) => (props.isUser ? "flex-end" : "flex-start")};
  word-wrap: break-word;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  text-align: ${(props) => (props.isUser ? "right" : "left")};
  font-size: 15px;
  line-height: 2;

    p {
    margin-bottom: 1rem;
  }
    table {
    margin-top: 1rem;
   
  }
    p {
    margin-bottom: 0.75em;
  }
    h3 {
    margin-top: 0.75em;
  }

  p:last-child {
    margin-bottom: 0;
  }

`;


export const ShimmerMessage = styled.div`
  max-width: 85%;
  min-height: 50px;
  min-width: 180px;
  padding: 12px 16px;
  border-radius: 16px;
  background: var(--navbar-bg);
  color: var(--gold);
  align-self: flex-start;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  font-size: 15px;
  line-height: 1.4;
  position: relative;
  overflow: hidden;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      to right,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.8) 50%,
      rgba(255, 255, 255, 0) 100%
    );
    animation: shimmer 1.8s infinite linear;
  }

  @keyframes shimmer {
    0% {
      transform: translateX(-150%);
    }
    100% {
      transform: translateX(150%);
    }
  }
`;

export const ChatInputContainer = styled.div`
  padding: 5px 50px;
  background-color: var(--body-bg);
  border-top: 1px solid #e0e0e0;
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  backdrop-filter: blur(8px);

`;

export const FollowUpQuestionCard = styled.div`
  padding: 12px 16px;
  background-color: var(--body-bg);
  border-radius: 8px;
  color: var(--tittle-text);
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;
  min-width: fit-content;
  max-width: 200px;
  white-space: normal;
  font-size: 14px;

  &:hover {
    background-color: #c5a55c;
    color: white;
    transform: translateY(-2px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }
`;

export const FollowUpQuestionButton = styled.button`
  background: none;
  border: 1px solid #e1d6b0;
  color: #3c3424;
  padding: 10px 16px;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 14px;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:hover {
    background-color: var(--light-color);
    border-color: #c5a55c;
  }
`;
